import './footer.scss';
import { execOnLoad } from '@general/helpers';
import { getProduct } from '@services/product';
import Cookies from 'js-cookie';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFooter = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const klaviyoCta = sectionContainer.querySelector('[data-klaviyo-id]');
  window._klOnsite = window._klOnsite || [];
  if (klaviyoCta) {
    klaviyoCta.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof window?._klOnsite?.push !== 'undefined')
        window._klOnsite.push(['openForm', klaviyoCta.dataset.klaviyoId]);
    });
  }

  const productsWrapper = sectionContainer.querySelector(
    '.footer__last-view-products',
  );
  const lastView = sectionContainer.querySelector('.footer__last-view');
  if (productsWrapper) {
    const productHandles = JSON.parse(Cookies.get('gcds-last-view') ?? '[]');

    if (productHandles.length > 0) {
      productHandles.forEach((handle, i) =>
        getProduct({ handle }).then(({ url, featured_image, title }) => {
          const imgWrap = document.createElement('div');
          imgWrap.style.order = i;
          const link = document.createElement('a');
          link.href = url;
          link.title = title;
          const image = document.createElement('img');
          image.src = `${featured_image}&width=200`;

          link.appendChild(image);
          imgWrap.appendChild(link);
          productsWrapper.appendChild(imgWrap);
        }),
      );
      lastView.classList.remove('hidden');
    }

    if (
      productsWrapper.dataset.productHandle &&
      productHandles.indexOf(productsWrapper.dataset.productHandle) < 0
    ) {
      if (productHandles.length >= 4) productHandles.pop();
      Cookies.set(
        'gcds-last-view',
        JSON.stringify([
          productsWrapper.dataset.productHandle,
          ...productHandles,
        ]),
      );
    }
  }
};

execOnLoad(window.dAgency.initFooter, '.footer__section');
